import React from 'react';
import { toast } from 'react-toastify';

import Footer from 'components/Footer';
import Header from 'components/Header';

import { CartProvider } from 'context/Cart';
import { VariantProvider } from 'context/useVariant';

import AboutUsSection from './AboutUsSection';
import CatalogsSection from './CatalogsSection';
import ContactSection from './ContactSection';
import HeroSection from './HeroSection';
import VisitUsSection from './VisitUsSection';

function Home(): JSX.Element {
    return (
        <VariantProvider variant="public">
            <CartProvider
                onItemAdd={(): React.ReactText =>
                    toast.success('Libro añadido a carrito')
                }
                onItemRemove={(): React.ReactText =>
                    toast.success('Libro removido del carrito')
                }
            >
                <Header />
                <HeroSection />
                <AboutUsSection />
                <CatalogsSection />
                <VisitUsSection />
                <ContactSection />
                <Footer />
            </CartProvider>
        </VariantProvider>
    );
}

export default Home;
